/**
 * Sprint 7 — Legal config for revenioo.ai.
 *
 * Zentrale Betreiber- und Marken-Daten für Impressum/Datenschutz/AGB/Cookies.
 * Vorläufige Texte — müssen vor Veröffentlichung anwaltlich geprüft werden.
 */

export const BRAND = {
  name: "revenioo.ai",
  homepage: "https://revenioo.ai",
  contact_email: "hello@revenioo.ai",
};

export const OPERATOR = {
  legal_name: "Reviverz:AI Andreas Kosmatos",
  street: "Zugspitzstr. 66",
  zip: "86163",
  city: "Augsburg",
  country: "Deutschland",
  email: "info@reviverzai.de",
  vat_id: "DE354534723",
};

export const LEGAL_LINKS = [
  { href: "/impressum", label: "Impressum" },
  { href: "/datenschutz", label: "Datenschutz" },
  { href: "/agb", label: "AGB" },
  { href: "/cookies", label: "Cookies" },
];

export const DISCLAIMER =
  "Vorläufige Informationen — keine Rechtsberatung. Die finalen Rechtstexte müssen vor Veröffentlichung rechtlich geprüft werden.";

export const COOKIE_CONSENT_KEY = "revenioo_consent";
